import React, { PropsWithChildren } from 'react';

import styles from './SectionContainer.module.scss';

interface SectionContainerProps {}

const SectionContainer: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles.sectionContainer}>{children}</div>;
};

export default SectionContainer;
